function parseScopes(value) {
  if (!value) return ['openid', 'profile', 'email'];
  return String(value)
    .split(/[,\s]+/g)
    .map((s) => s.trim())
    .filter(Boolean);
}

export const microsoftSsoConfig = {
  // Used for MSAL config.
  tenantId: process.env.REACT_APP_AAD_TENANT_ID || '',
  clientId: process.env.REACT_APP_AAD_CLIENT_ID || '',
  authority:
    process.env.REACT_APP_AAD_AUTHORITY ||
    (process.env.REACT_APP_AAD_TENANT_ID
      ? `https://login.microsoftonline.com/${process.env.REACT_APP_AAD_TENANT_ID}`
      : ''),
  redirectUri: process.env.REACT_APP_AAD_REDIRECT_URI || window.location.origin,
  scopes: parseScopes(process.env.REACT_APP_AAD_SCOPES),
};

